import { store } from "@store";
import AsyncStorage from "@react-native-async-storage/async-storage";

const getTokenZ = async () => {
  let token = null;
  token = store?.getState()?.auth?.userToken;
  if (!token) {
    token = await AsyncStorage.getItem("user_token");
  }
  return token;
};

export default getTokenZ;
